export default __webpack_public_path__ + "static/media/icon_finishingtype_Patterned.c56b9a2d.png";